export default __webpack_public_path__ + "static/principle-sentient-dark-5db662a4d9a4e63dbe316cd9180fbe8c949810cb9b0a70b95205a4ca8eb12ca7.png";